export default __webpack_public_path__ + "static/media/451.911c9205.png";